import React, { useMemo } from "react";

import { useRuleBuilderContext } from "containers/Rules/context/useRuleBuilderContext";
import { COLUMN_HEADER_KEYS, RULE_SUBTYPES, RULE_TYPES } from "globals/constants";
import { useDictionary } from "hooks";

export const useRuleTypeActionLabel = (ruleType, ruleSubType) => {
	const { formType = "" } = useRuleBuilderContext();

	const getLabelsForForm = () => {
		switch (formType.toUpperCase()) {
		case COLUMN_HEADER_KEYS.PROPOSAL:
			return "ruleBuilder.actionBuilder.actionLabels.proposalForm";
		case COLUMN_HEADER_KEYS.AWARD:
			return "ruleBuilder.actionBuilder.actionLabels.awardForm";
		default:
			return "ruleBuilder.actionBuilder.actionLabels.default";
		}
	};

	const dictionary = useDictionary(getLabelsForForm());

	return useMemo(() => {
		//let type = dictionary[ruleType];
		switch (ruleType) {
		case RULE_TYPES.NOTIFICATION:
			return dictionary[ruleSubType];
		case RULE_TYPES.UNIT_REVIEW:
			if(ruleSubType === RULE_SUBTYPES.SPECIFIC_UNIT) {
				return dictionary[`${RULE_TYPES.UNIT_REVIEW}_${RULE_SUBTYPES.SPECIFIC_UNIT}`];
			}

			return dictionary[ruleType];
		default:
			return dictionary[ruleType];
		}
	}, [ dictionary, ruleSubType, ruleType ]);
};

export const useActionText = (rule, name) => {
	const actionLabel = useRuleTypeActionLabel(rule.ruleType, rule.ruleSubType);

	switch (rule.ruleType) {
	case RULE_TYPES.AD_HOC_NOTIFICATION:
	case RULE_TYPES.AD_HOC_REVIEW:
		return (
			<>
				<span dangerouslySetInnerHTML={{ __html: actionLabel }} /> <b> {name}</b>
			</>
		);
	case RULE_TYPES.UNIT_REVIEW:
		if (rule.ruleSubType === RULE_SUBTYPES.SPECIFIC_UNIT) {
			return (
				<>
					<span dangerouslySetInnerHTML={{ __html: actionLabel }} /> <b> {name}</b>
				</>
			);
		}

		return (
			<span dangerouslySetInnerHTML={{ __html: actionLabel }} />
		);
	case RULE_TYPES.INFOREADY_REVIEW:
		return (
			<>
				<span
					dangerouslySetInnerHTML={{ __html: actionLabel }}
				/>
				<span> {name}</span>
			</>
		);
	case RULE_TYPES.NOTIFICATION:
		if (rule.ruleSubType === RULE_SUBTYPES.SPECIFIC_UNIT) {
			return (
				<>
					<span dangerouslySetInnerHTML={{ __html: actionLabel }} /> <b> {name}</b>
				</>
			);
		}

		return (
			<span dangerouslySetInnerHTML={{ __html: actionLabel }} />
		);

	default:
		return (
			<span dangerouslySetInnerHTML={{ __html: actionLabel }} />
		);
	}
};
